import React from 'react'

export default function Banner({ type = 'info', message, onDismiss }) {
  const styles = {
    info: 'border-blue-300 bg-blue-50 text-blue-900',
    warning: 'border-yellow-300 bg-yellow-50 text-yellow-900',
    error: 'border-red-300 bg-red-50 text-red-900',
  }[type]

  if (!message) return null

  return (
    <div className={`flex items-start justify-between gap-4 rounded-md border px-3 py-2 text-sm ${styles}`}>
      <p>{message}</p>
      {onDismiss && (
        <button onClick={onDismiss} className="text-xs underline underline-offset-2">
          Dismiss
        </button>
      )}
    </div>
  )
}
